import { saveBlob } from './download'

/**
 * Generate and trigger a browser download of a CSV template file.
 */
function downloadCsv(filename: string, headers: string[], sampleRows: string[][]) {
  const escape = (v: string) => {
    if (v.includes(',') || v.includes('"') || v.includes('\n')) {
      return `"${v.replace(/"/g, '""')}"`
    }
    return v
  }

  const lines = [
    headers.map(escape).join(','),
    ...sampleRows.map((row) => row.map(escape).join(',')),
  ]

  saveBlob(new Blob([lines.join('\n')], { type: 'text/csv;charset=utf-8;' }), filename)
}

/**
 * Download a client import template CSV with headers and 2 sample rows.
 */
export function downloadClientTemplate() {
  downloadCsv(
    'client-import-template.csv',
    ['name', 'vertical', 'plan', 'status', 'health', 'mrr', 'website', 'notes'],
    [
      ['Acme Dental', 'Dental', 'Retainer + Answer', 'active', 'good', '1200', 'acmedental.com', 'Monthly touchpoint set'],
      ['Loft & Co Salon', 'Beauty', 'Answer ($99/mo)', 'active', 'watch', '99', 'loftcosalon.com', ''],
    ],
  )
}

/**
 * Sample rows quote the tenant's own disciplines — a template that suggests a
 * discipline they removed would be rejected on the way back in.
 */
function samples(disciplines: string[]): [string, string] {
  const first = disciplines[0] ?? 'ops'
  return [first, disciplines[1] ?? first]
}

/**
 * Download a team member import template CSV with headers and 2 sample rows.
 */
export function downloadTeamTemplate(disciplines: string[]) {
  const [a, b] = samples(disciplines)
  downloadCsv(
    'team-import-template.csv',
    ['name', 'email', 'title', 'role', 'disciplines', 'capacity_hrs_week', 'status'],
    [
      ['Sarah Chen', 'sarah@company.com', 'Marketing Lead', 'member', b, '40', 'roster_only'],
      ['Marcus Webb', 'marcus@company.com', 'Ops Manager', 'admin', `${a}; ${b}`, '32', 'invite'],
    ],
  )
}

/**
 * Download a task import template CSV with headers and 2 sample rows.
 */
export function downloadTaskTemplate(disciplines: string[]) {
  const [a, b] = samples(disciplines)
  downloadCsv(
    'task-import-template.csv',
    ['title', 'details', 'status', 'priority', 'discipline', 'due', 'client', 'assignee', 'estimate_hrs'],
    [
      [
        'Kickoff call',
        'Agenda, attendees and goals for the first call',
        'todo',
        'high',
        a,
        '2026-08-01',
        'Acme Dental',
        'Sarah Chen',
        '1',
      ],
      [
        'Draft ad creative',
        'Two concepts for the launch campaign',
        'in_progress',
        'med',
        b,
        '2026-08-05',
        'Loft & Co Salon',
        'Marcus Webb',
        '3',
      ],
    ],
  )
}
